import React from "react";
import { ArrowLeft, MoreVertical } from "lucide-react";

/* ===================================================== */
/* PROJECT HEADER                                        */
/* ===================================================== */

export default function ProjectHeader({
  project,
  onBack,
  onEdit,
  onDelete,
}) {
  if (!project) return null;

  const {
    name,
    _id,
    startDate,
    endDate,
    responsibleTeamId,
    responsibleUserId,
  } = project;

  /* ===================================================== */
  /* HELPERS                                               */
  /* ===================================================== */

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString() : "—";

  const shortId = _id ? _id.slice(-8) : "—";

  /* ===================================================== */
  /* RENDER                                                */
  /* ===================================================== */

  return (
    <div className="space-y-4">

      {/* ================= TOP BAR ================= */}
      <div className="flex items-start justify-between gap-4">

        {/* LEFT */}
        <div className="flex items-start gap-3">

          {/* BACK */}
          <button
            onClick={onBack}
            className="flex items-center gap-1 rounded border px-3 py-1.5 text-sm hover:bg-gray-50"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>

          {/* TITLE */}
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              {name || "Untitled Project"}
            </h1>
          </div>
        </div>

        {/* RIGHT ACTIONS */}
        <div className="flex items-center gap-2">

          {onEdit && (
            <button
              onClick={onEdit}
              className="rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50"
            >
              Edit
            </button>
          )}

          {onDelete && (
            <button
              onClick={onDelete}
              className="rounded-lg border px-3 py-1.5 text-sm text-red-600 hover:bg-red-50"
            >
              Delete
            </button>
          )}

          {/* FUTURE MENU */}
          <button className="rounded-lg border p-2 hover:bg-gray-50">
            <MoreVertical className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* ================= META ================= */}
      <div className="flex flex-wrap gap-4 text-sm text-gray-600">

        <Meta label="Project ID" value={shortId} mono />

        <Meta label="Start" value={formatDate(startDate)} />
        <Meta label="End" value={formatDate(endDate)} />

        {responsibleTeamId && (
          <Meta
            label="Team"
            value={
              typeof responsibleTeamId === "object"
                ? responsibleTeamId.name
                : "Assigned"
            }
          />
        )}

        {responsibleUserId && (
          <Meta
            label="Owner"
            value={
              typeof responsibleUserId === "object"
                ? responsibleUserId.name
                : "Assigned"
            }
          />
        )}
      </div>
    </div>
  );
}

/* ===================================================== */
/* META COMPONENT                                        */
/* ===================================================== */

function Meta({ label, value, mono = false }) {
  return (
    <div>
      <span className="font-medium">{label}:</span>{" "}
      <span className={mono ? "font-mono text-gray-700" : ""}>
        {value || "—"}
      </span>
    </div>
  );
}